'use client'

import * as VisuallyHiddenPrimitive from '@radix-ui/react-visually-hidden'

/**
 * VisuallyHidden component
 *
 * Hides content visually while keeping it accessible to screen readers.
 * Useful for providing accessible labels to interactive elements.
 *
 * @example
 * <Button>
 *   <VisuallyHidden>Close dialog</VisuallyHidden>
 *   <X className="h-4 w-4" />
 * </Button>
 */
const VisuallyHidden = VisuallyHiddenPrimitive.Root

export { VisuallyHidden }
